import { gql } from '@apollo/client';

export interface RouteOrderPoolItem {
    id: number | null;
    orderId: number | null;
    trackingNumber: string | null;
    status: number | null;
    zipcode: string | null;
    latitude: number | null;
    longitude: number | null;
    stopNumber: number | null;
}

export interface GetRouteOrdersResponse {
    getRouteOrders: {
        orderList: RouteOrderPoolItem[];
        prePlanningCompleted: boolean | null;
    };
}

export interface GetRouteOrdersVariables {
    request: {
        warehouseId: number;
        areaId: number;
    };
}

export const GET_ROUTE_ORDERS_FOR_DSP = gql`
    query GetRouteOrdersForDsp($request: GetRouteOrdersRequestInput!) {
        getRouteOrdersForDsp(request: $request) {
            orderList {
                id
                orderId
                trackingNumber
                status
                zipcode
                latitude
                longitude
                stopNumber
            }
            prePlanningCompleted
        }
    }
`;

export const GET_ROUTE_ORDERS = gql`
    query GetRouteOrders($request: GetRouteOrdersRequestInput!) {
        getRouteOrders(request: $request) {
            orderList {
                id
                orderId
                trackingNumber
                status
                zipcode
                latitude
                longitude
                stopNumber
            }
            prePlanningCompleted
        }
    }
`;
